import React from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, Radio } from '@zocdoc/components/src/radio';
import { injectIntl } from 'react-intl';
import { LOCALIZED_STRINGS, DEFAULT } from '../constants';

const FullLanguages = ({
    intl,
    languageId,
    languages,
    onChangeCallback,
}) => {
    const noPreference = intl.formatMessage(LOCALIZED_STRINGS.NoPreference);
    const radios = languages.map(l => (
        <Radio
            key={l.id}
            data-test={l.name}
            text={l.name}
            value={l.id}
        />
    ));

    const onChange = update => {
        if (update !== languageId) {
            onChangeCallback({ languageId: update });
        }
    };

    radios.unshift(
        <Radio
            key={DEFAULT}
            data-test="search-refine-language-filter-full-noPreference"
            text={noPreference}
            value={DEFAULT}
        />
    );

    return (
        <div data-test="search-refine-language-filter-full">
            <RadioGroup
                flush
                name="full-language"
                onChangeCallback={onChange}
                renderWithoutBox
                selectedValue={languageId}
            >
                {radios}
            </RadioGroup>
        </div>
    );
};

FullLanguages.propTypes = {
    languageId: PropTypes.string.isRequired,
    languages: PropTypes.array.isRequired,
    onChangeCallback: PropTypes.func.isRequired,
};

export default injectIntl(FullLanguages);
